import React, { ReactNode } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { Button } from "@leafly-com/frontend-components";

type ActionButtonProps = {
  children?: ReactNode;
  className?: string;
  href?: string;
  icon?: string;
  onClick?: (e: Event) => void;
  variant?: string;
};

export const ActionButton = forwardRef(
  ({ icon, className, children, ...props }: ActionButtonProps, ref) => (
    <Button
      className={classNames(
        "flex justify-center items-center flex-grow mx-xs w-full",
        className
      )}
      size="small"
      ref={ref}
      {...props}
    >
      {!!icon && (
        <svg height="16" width="16" className="mr-xs">
          <use href={`#${icon}`} xlinkHref={`#${icon}`}></use>
        </svg>
      )}
      {children}
    </Button>
  )
);
